import React from 'react';
import ReactMarkdown from 'react-markdown';
import './TermsOfService.css';
import { termsContent } from './termsContent';

const TermsOfService = () => {

    return (
        <>
            <title>Terms of Service - WizeHelper</title>
            <meta name="description" content="Read the WizeHelper Terms of Service to understand your rights and obligations when using our AI-powered Reddit analytics tools." />
            <div className="terms-of-service-container">
                <ReactMarkdown>{termsContent.content}</ReactMarkdown>
            </div>
        </>
    );
};

export default TermsOfService;
